import { render, staticRenderFns } from "./scanHistory.vue?vue&type=template&id=5f6a4a1c&scoped=true"
import script from "./scanHistory.vue?vue&type=script&lang=js"
export * from "./scanHistory.vue?vue&type=script&lang=js"
import style0 from "./scanHistory.vue?vue&type=style&index=0&id=5f6a4a1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6a4a1c",
  null
  
)

export default component.exports